import { render, staticRenderFns } from "./IconArrowsSwap.vue?vue&type=template&id=93ccc3ca"
import script from "./IconArrowsSwap.vue?vue&type=script&lang=js"
export * from "./IconArrowsSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports